export default "__VITE_ASSET__9ca0473b__"